import { Component, input, output, signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import * as fromSharedUi from '@sandbox-platform/shared-ui';
import { AttendanceAutoCloseLogDTO } from '../../attendance-settings.types';

export const DAY_OPTIONS = [5, 15, 20, 30, 45] as const;
export type DayOption = (typeof DAY_OPTIONS)[number];

@Component({
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    fromSharedUi.NoRecordsComponent,
  ],
  selector: 'lib-attendance-auto-close-logs-tab',
  templateUrl: './attendance-auto-close-logs-tab.component.html',
  host: {
    class: 'block h-full min-h-0',
  },
})
export class AttendanceAutoCloseLogsTabComponent {
  readonly logs = input.required<AttendanceAutoCloseLogDTO[]>();
  readonly isLoading = input<boolean>(false);

  readonly daysChanged = output<number>();

  readonly dayOptions = DAY_OPTIONS;
  readonly selectedDays = signal<DayOption>(15);

  onDaysChange(days: DayOption): void {
    this.selectedDays.set(days);
    this.daysChanged.emit(days);
  }

  statusClass(status: AttendanceAutoCloseLogDTO['status']): string {
    const base =
      'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium';
    switch (status) {
      case 'success':
        return `${base} bg-green-100 text-green-800`;
      case 'skipped':
        return `${base} bg-yellow-100 text-yellow-800`;
      case 'failed':
        return `${base} bg-red-100 text-red-800`;
    }
  }
}
